<template>
    <div>
        <div class="card-icons">
            <span
                v-for="(element, index) in orderStatus"
                :key="index"
                class="pointer"
            >
                <img
                    :src="require(`@assets/images/${renderIcon(element)}`)"
                    alt="info"
                />

                <md-tooltip md-direction="bottom">
                    <span ng-bind-html="msg | unsafeSpecial" class="uppercase">
                        {{ statusText[index] }}
                    </span>
                </md-tooltip>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orderStatus: {
            type: Array,
            default: () => {
                return [0, 0, 0];
            }
        }
    },

    data() {
        return {
            iconFirst: 'icon_tick_green.svg',
            iconSecond: 'icon_tick_gray.svg',
            statusText: [
                this.$t('deposits.sent'),
                this.$t('orders.conversation'),
                this.$t('orders.taken')
            ]
        };
    },

    methods: {
        renderIcon(item) {
            return item ? this.iconFirst : this.iconSecond;
        }
    }
};
</script>
